// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__XeCGV","small":"Icon_small__Ga43Z","selected":"Icon_selected__fahs3","light":"Icon_light__9S3rD","badge":"Icon_badge__6JuEI"};